<template lang="pug">
  .dashboard-view
    v-container.pa-0(style="max-width:960px")
      v-row.mb-0(no-gutters)
        v-col(cols="12" v-if="member.role === 'Admin'")
          donation-chart(:company="company" :stickyFilter="true" @spanChange="handleChangeSpan" @campaignChange="handleChangeCampaign($event)" :isAnalytics="true")

        v-col.mt-6(cols="12")
          .h6.ma-2.mb-3 {{ $t('fundraiser_ranking') }}
          fundraisers-ranking(:company="company"  :span.sync="selectedSpan" :dateRange="customDateFilterRange" :campaign="selectedCampaign")

        v-col.mt-6(cols="12")
          .h6.ma-2.mb-3 {{ $t('campaign_ranking') }}
          campaigns-ranking(:company="company" :span.sync="selectedSpan" :dateRange="customDateFilterRange")     
</template>

<script>
import { mapState, mapActions } from 'vuex'
import DonationChart from '@/components/donation/analytics/DonationChart.vue'
import CampaignsRanking from '@/components/donation/analytics/CampaignsRanking.vue'
import FundraisersRanking from '@/components/donation/analytics/FundraisersRanking.vue'

export default {
  name: 'Analytics',
  components: { DonationChart, CampaignsRanking, FundraisersRanking },
  props: ['company', 'menu'],
  data: () => ({
    metrics: null,
    customDateFilterRange: [],
    selectedSpan: 'month',
    selectedCampaign: ''
  }),
  computed: {
    ...mapState('user', ['member'])
  },
  watch: {
    company (val) {
      if (val) {
        this.fetchMetrics('month')
      }
    }
  },
  mounted () {
    this.fetchMetrics('month')
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    handleChangeSpan (data) {
      this.selectedSpan = data.range.id
      this.customDateFilterRange = data.selectedDateRange
      this.fetchMetrics(data.range.id, data.selectedDateRange)
    },
    handleChangeCampaign (id) {
      this.selectedCampaign = id
    },
    formatDateRange (range) {
      if (range.length === 0) {
        return 'Date Range'
      } else if (range.length === 1) {
        const [year, month, day] = range[0].split('-')
        return `${day}/${month}/${year} -`
      } else {
        const [year1, month1, day1] = range[0].split('-')
        const [year2, month2, day2] = range[1].split('-')
        return `${day1}/${month1}/${year1} - ${day2}/${month2}/${year2}`
      }
    },
    runCustomDateFilter () {
      this.customDateFilterMenu = false
      this.fetchMetrics('custom', this.customDateFilterRange)
    },
    fetchMetrics (span, range=null) {
      let url = `/donations/${this.company.slug}/charts/?span=${span}`
      if (span === 'custom') {
        url = `/donations/${this.company.slug}/charts/?span=custom&from=${range[0]}&until=${range[1]}`
      }
      this.$axios.get(url)
        .then(resp => {
          this.metrics = resp.data
        })
        .catch(e => {
          this.showMessage(['error', e.response.data[0]])
          if (range) {
            this.customDateFilterRange.pop()
            this.customDateFilterMenu = true
          }
        })
    }
  }
}
</script>

<style>
  .v-sheet--offset {
    top: -24px;
    position: relative;
  }
  div.v-picker__title {
    height: 0;
    padding: 0;
  }
</style>

<i18n>
{
  "en": {
    "sales_funnel": "Sales Funnel",
    "campaign_ranking": "Campaign Ranking",
    "fundraiser_ranking": "Fundraiser Ranking"
  },
  "id": {
    "sales_funnel": "Funnel Penjualan",
    "campaign_ranking": "Peringkat Kampanye",
    "fundraiser_ranking": "Peringkat Penggalang Dana"
  }
}
</i18n>